import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/campaign";
import { track } from "@/lib/track";
import { Reveal } from "./Reveal";

export const FinalCTA = ({ variant, onStartGuide }) => (
  <section data-testid="final-cta-section" className="py-16 sm:py-24 bg-[var(--brand-cream)] border-t border-[var(--brand-gold-soft)]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 text-left sm:text-center">
      <Reveal>
        <h2 className="font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)] leading-tight">
          You don&rsquo;t have to have it all figured out before you come in.
        </h2>
        <p className="mt-5 text-lg leading-relaxed">
          Start by learning what the visit involves. We&rsquo;ll help you understand the next step.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row sm:justify-center gap-4">
          <button
            data-testid="final-cta-button"
            onClick={onStartGuide}
            className="inline-flex items-center justify-center bg-[var(--brand-navy)] text-white text-lg font-semibold px-10 py-4 hover:bg-[var(--brand-navy-deep)] transition-colors"
          >
            Find My Next Step
          </button>
          <a
            data-testid="final-cta-call-link"
            href={PHONE_TEL} data-call-location="final_cta"
            onClick={() => track(variant, "call_click")}
            className="inline-flex items-center justify-center gap-2 border-2 border-[var(--brand-navy)] text-[var(--brand-navy)] text-lg font-semibold px-8 py-[14px] bg-white hover:bg-[var(--brand-bg)] transition-colors"
          >
            <Phone className="h-5 w-5" aria-hidden="true" /> Call {PHONE_DISPLAY}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
